import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignalStream, faCalendar } from '@fortawesome/pro-light-svg-icons';

import './styles.scss';
import moment from 'moment';

interface TimestampInfoProps {
  timestamp: number;
  textFormat?: string;
  keepLocalTime?: boolean;
}

const DEFAULT_TEXT_FORMAT = 'DD MMM yyyy - HH:mm';

const TimestampInfo: React.FC<TimestampInfoProps> = ({
  timestamp,
  textFormat,
  keepLocalTime = false,
}) => {
  const formattedDate = moment(timestamp)
    .utc(keepLocalTime)
    .format(textFormat || DEFAULT_TEXT_FORMAT);

  return (
    <div className="timestamp-info">
      <div className="live-data-container">
        <FontAwesomeIcon icon={faSignalStream} className="signal-icon" />
        <span className="live-text">Live data</span>
      </div>
      <div className="date-container">
        <FontAwesomeIcon icon={faCalendar} className="calendar-icon" />
        <span className="date-text">{formattedDate} UTC</span>
      </div>
    </div>
  );
};

export default TimestampInfo;
